import { Component, OnInit, Input, Output, OnChanges, EventEmitter, OnDestroy} from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ContextFactory } from '@shared/factories/context/context.factory';
import { GlobalCfgFactory } from '@shared/factories/global-cfg/global-cfg.factory';
import { UserPermisionsFactory } from '@shared/factories/user-permisions/user-permisions.factory';
import { ConvertDatePipe } from '../../filters/convert-date/convert-date.pipe';
import { ConvertBytesPipe } from '../../filters/convert-bytes/convert-bytes.pipe';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { TooltipModule } from 'primeng/tooltip';
import { SpanTooltipComponent } from '../span-tooltip/span-tooltip.component';
import { SharedModule } from 'primeng/api';
import { AfTranslateDirective } from '../../modules/translate/directive/af-translate.directive';
import { NgClass } from '@angular/common';
import { ExtensionDocumentPipe } from '@shared/filters/extension-document/extension-document.pipe';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { ButtonWithMenuActionComponent } from "../button-with-menu-action/button-with-menu-action.component";
import { CustomLandingFactory } from '@shared/factories/custom-landing/custom-landing.factory';
import { BroadcastService } from '@shared/services/broadcast/broadcast.service';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';
import { LoaderFactory } from '@shared/factories/loader/loader.factory';
import { ExpandedMenuService } from '@shared/services/expanded-menu/expanded-menu.service';
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';
import { DocumentActionsService } from '@shared/services/document-actions/document-actions.service';
import { cloneDeep } from 'lodash';
import moment from 'moment';

@Component({
  selector: 'attachments-template',
  templateUrl: './attachments-template.component.html',
  standalone: true,
  imports: [NgClass, AfTranslateDirective, SharedModule, SpanTooltipComponent, TooltipModule, AfTranslatePipe, ConvertBytesPipe, ConvertDatePipe, ExtensionDocumentPipe, ButtonWithMenuActionComponent]
})
export class AttachmentsTemplateComponent implements OnInit, OnChanges, OnDestroy {
  skin: string = this.globalCfg.skin;
  isLanding: boolean = this.customLanding.isLanding();
  currentComponent = this.route.snapshot.data['componentName'];
  isMonitoring: any = this.route.snapshot.data['isMonitoring'];
  icamConceptObject = (this.skin === 'icam-red' && this.isLanding && this.context.view && this.context.view.extraData && this.context.view.extraData.masterConceptId && this.context.view.extraData.masterConceptObjectId);
  userPermissions = this.permisions.getPermissions();
  subscribers: any = {};
  attachmentsTemplate:any = {
    showTemplate: !(this.skin === 'icam-red' && this.isLanding),
    comments: '',
    attachmentList: [],
    newDocuments: [],
    titleHeader: this.icamConceptObject? 'attachments.related-documentation' : 'attachments.documents',
    infoNoDocuments:  this.icamConceptObject? 'attachments.without-documents-related' : 'attachments.without-documents',
    expandedMenu: [{
      icon: 'lf-icon-up-file',
      name: this.translate.instant('up-document.file'),
      action: 'upDocument'
    }, {
      icon: 'lf-icon-office365',
      name: this.translate.instant('attach-document.create-in-office-online'),
      action: 'createOffice'
    }, {
      icon: 'lf-icon-documentation',
      name: this.translate.instant('attach-document.associate-documentation-files'),
      action: 'addDocument'
    }],
    itemOptions: {}
  }

  constructor(private route:ActivatedRoute,
    private globalCfg: GlobalCfgFactory,
    private context: ContextFactory,
    private permisions: UserPermisionsFactory,
    private translate: AfTranslateFactory,
    private loader: LoaderFactory,
    private customLanding: CustomLandingFactory,
    private documentActions: DocumentActionsService,
    private broadcastService: BroadcastService,
    private commonUtilsService: CommonUtilsService,
    private apiService: ApiServiceService,
    private expandedMenuService: ExpandedMenuService,
    private modalService: ModalServiceService) {}

    @Input() itemSelected: any = null;
    @Input() concept: any = null;
    @Input() attachmentList: any = null;
    @Input() typeFrom: string = '';
    @Input() lockComToManager: boolean = false;
    @Output() launchAction = new EventEmitter();
    @Input() disableDelete: boolean = false;

  ngOnInit(): void {
    this.watchChangeListDocuments();
  }

  ngOnChanges(): void {
    let attachmentsTemplate: any = this.attachmentsTemplate;
    if(this.itemSelected){
      attachmentsTemplate.itemSelected = this.itemSelected;
      if(attachmentsTemplate.itemSelected?.taskId){
        attachmentsTemplate.hideAddDocuments = (attachmentsTemplate.itemSelected.taskStateId && (attachmentsTemplate.itemSelected.taskStateId === 5 || attachmentsTemplate.itemSelected.taskStateId === 6 ));
        if (attachmentsTemplate.itemSelected && attachmentsTemplate.itemSelected.taskTypeId === 2){
          attachmentsTemplate.titleHeader = 'attach-document.documents-to-sign';
        }
      }
      if(attachmentsTemplate.itemSelected && (attachmentsTemplate.itemSelected.conceptObjectId || attachmentsTemplate.itemSelected.taskId || (this.isLanding && !attachmentsTemplate.itemSelected.conceptObjectId && !attachmentsTemplate.itemSelected.taskId))){
        this.getAttachmentsDocument();
      }else{
        attachmentsTemplate.closeSpinner = true;
      }
    }else if(this.typeFrom === 'preview'){
      attachmentsTemplate.closeSpinner = true;
    }
    if(this.concept){
      attachmentsTemplate.concept = this.concept;
    }
  }

  watchChangeListDocuments(){
    this.subscribers.changeDocumentToListBroadcast = this.broadcastService.subscribe('changeDocumentToList', ( data:any)=>{
      if(data.newConcept &&this.isLanding){
        this.getAttachmentsDocument();
      }else if(this.attachmentsTemplate.attachmentList){
        this.attachmentsTemplate.attachmentList.forEach((attach:any) => {
          if(attach.name === data.document.name){
            attach.conceptObjectId = data.document.conceptObjectId;
            attach.editPath = data.document.editPath;
            attach.documentObjectId = data.document.documentObjectId;
          }
        });
      }
    })
    this.subscribers.addAttachmentsDocumentBroadcast = this.broadcastService.subscribe('addAttachmentsDocument', (data:any)=>{
      if(!this.attachmentsTemplate.attachmentList){
        this.attachmentsTemplate.attachmentList = [];
      }
      data.document.extension = data.document.name.substr(data.document.name.lastIndexOf('.')+1, data.document.name.length);
      if(data.document.deleted){
        let index = this.attachmentsTemplate.attachmentList.findIndex((item: any)=>{ return item.documentObjectId === data.document.documentObjectId});
        this.attachmentsTemplate.attachmentList.splice(index,1);
      }else{
        let hasInArray =  this.attachmentsTemplate.attachmentList.filter((attachItem:any)=>{return attachItem.name === data.document.name}).length
        if(!hasInArray){
          this.attachmentsTemplate.attachmentList.splice(this.attachmentsTemplate.attachmentList.length, 0, data.document);
        }

      }

    })
    this.subscribers.deleteAttachmentsDocument =this.broadcastService.subscribe('deleteAttachmentsDocument', (data:any)=>{
      this.attachmentsTemplate.attachmentList = this.commonUtilsService.deleteElement(data.document, this.attachmentsTemplate.attachmentList, 'documentObjectId');
    })
    this.subscribers.deleteAllAttachmentsDocumentBroadcast = this.broadcastService.subscribe('deleteAllAttachmentsDocument', (data:any)=>{
      this.attachmentsTemplate.attachmentList = [];
    })
  }

  getAttachmentsDocument(documentAdded:boolean = false) {
    let that: any = this.attachmentsTemplate;
    let url:string = 'documentobjects/' + that.itemSelected.conceptObjectId;
    that.documentsCantBeDeleted = false;
    if(this.isLanding && window.location.pathname.indexOf('/field-container/') !== -1){
      url = 'documentobjects/insharedfieldcontainer/'+ that.itemSelected.conceptObjectId + '/' + + this.route.snapshot.params['fieldContainerId'];
    }else if(this.isLanding && window.location.pathname.indexOf('/task-concept-evaluated/') !== -1){
      url = 'documentobjects/insharedevaluationtask/'+ that.itemSelected.conceptObjectId;
    }else if(this.isLanding && this.concept?.sharedReadOnly && that.itemSelected.conceptObjectId){
      url = 'documentobjects/insharedreadconceptobject/' + that.itemSelected.conceptObjectId;
    }else if(this.isLanding && !that.itemSelected.conceptObjectId && !that.itemSelected.taskId){
      url = 'publicconceptdoc/concept/' + that.itemSelected.conceptId;
      that.documentsCantBeDeleted = true;
    }else if (that.itemSelected && that.itemSelected.taskId) {
      url = 'documentobjects/task/' + that.itemSelected.taskId;
    }

    this.apiService.get(url)
      .then((data:any) => {
        if(!(this.skin === 'icam-red' && this.isLanding && !data.documents.length)){
          that.showTemplate = true ;
        }
        if(this.isMonitoring){
          this.getReferenceDocument(data, documentAdded);
        }else{
          that.attachmentList = this.isLanding && that.itemSelected.conceptObjectId && !that.itemSelected.taskId?data.documents:data;
          this.configureGetDocuments(data, documentAdded);
        }
      }, (errorData:any) => {
        that.attachmentList = [];
        this.loader.closeError()
        that.closeSpinner = true;
      });
  }

  getReferenceDocument(documentsList:any = [], documentAdded:boolean = false){
    this.apiService.get('publicconceptdoc/concept/' + this.attachmentsTemplate.itemSelected.conceptId)
      .then((data:any) => {
        this.attachmentsTemplate.attachmentList = data.concat(documentsList.documents);
        this.configureGetDocuments(documentsList, documentAdded);
      }, (errorData:any) => {
        this.attachmentsTemplate.attachmentList = [];
        this.loader.closeError()
        this.attachmentsTemplate.closeSpinner = true;
      });
  }

  configureGetDocuments(data: any, documentAdded:boolean = false){
    let that: any = this.attachmentsTemplate;
    if(this.isLanding && !that.itemSelected.taskId && that.itemSelected.conceptObjectId){
      that.concept.documentation = data;
      let folders = data.subFolders;
      this.extractDocuments(that.attachmentList, folders);
    }
    that.attachmentList.forEach((document:any) => {
      document.hideDeleteOption = this.configureCanBeDeletedDocument(document);
      if(this.isLanding && !that.itemSelected.taskId){
        document.extension = document.name.substr(document.name.lastIndexOf('.')+1, document.name.length);
      }
      document.officeOnlineType = this.expandedMenuService.officeOnline.includes(document.extension);
    });
    if (documentAdded) {
      this.modalService.successModal({text: this.translate.instant('attachments.add-ok-documentation')});
    }
    this.loader.closeLoader(['alert-condept-edit-alert']);
    that.closeSpinner = true;
  }

  configureCanBeDeletedDocument(document: any){
    if(this.userPermissions === 'none'){
      return true;
    }else{
      let hideDeleteOption: boolean = false;
      if(this.isLanding){
        hideDeleteOption = this.currentComponent !== 'sharedTask' || this.attachmentsTemplate.itemSelected.taskStateId === 5 || this.attachmentsTemplate.itemSelected.taskStateId === 6;
      }else{
        hideDeleteOption = (this.attachmentsTemplate.itemSelected.taskTypeId === 5 && (this.attachmentsTemplate.itemSelected.taskStateId === 5 || this.attachmentsTemplate.itemSelected.taskStateId === 6)) && !((this.attachmentsTemplate.itemSelected.taskTypeId !== 2 || this.attachmentsTemplate.itemSelected.conceptId) && document.canBeDeleted);
      }
      return hideDeleteOption;
    }
  }

  extractDocuments(extension:any, subFolders:any){

    // daba error porque en ocasiones no llegaba como array
     if (!Array.isArray(subFolders)) return;

    subFolders.forEach((subfolder:any) => {
      subfolder.documents.forEach((document:any) => {
        extension.push(document);
      });
      subfolder.subFolders.forEach((innerSubfolder:any) => {
        this.extractDocuments(extension, innerSubfolder);
      });
    });
  }

  configureItemOptions(){
    let expandedMenu: any = [];
    this.attachmentsTemplate.expandedMenu.forEach((option: any) => {
      switch(option.action){
        case 'createOffice':
          option.disabled = !this.attachmentsTemplate.itemSelected.conceptObjectId && !this.attachmentsTemplate.itemSelected.taskId;
          expandedMenu.push(option);
          break;
        case 'addDocument':
          if(this.currentComponent !== 'genericTask'){
            option.disabled = this.lockComToManager || !this.concept.documentation.totalDocuments || this.concept.documentation.totalDocuments === this.attachmentsTemplate.attachmentList.length;
            expandedMenu.push(option);
          }
          break;
        default:
          expandedMenu.push(option);
          break;
      }
    });
    this.attachmentsTemplate.itemOptions.expandedMenu = expandedMenu;
  }

  launchActionDocuments(action:string, document:any = null){
    switch(action){
      case 'upDocument':
        if(!this.lockComToManager){
          this.upDocument();
        }
        break;
      case 'createOffice':
        let configuration : any = {
          concept: this.concept,
          type: 'task',
          listDocuments: this.concept?this.concept.documentation.documents:this.attachmentsTemplate.attachmentList,
        }
        this.modalService.newDocument(configuration)
          .subscribe((result:any)=>{
            if(result.result==='ok'){
              this.loader.openLoader('attachment-document');
              this.createNewDocument(result);
            }
          })
        break;
      case 'delete':
        // if(this.isLanding){

        // }else
        if(document.documentStatusId && (document.documentStatusId === 3 || document.documentStatusId === 4 || document.documentStatusId === 6)){
          this.modalService.errorModal({ text: this.translate.instant('documentation-list.error-delete-document-signed') });
        }else{
          this.deleteDocument(document);
        }
        break;
      case 'download':
        // if(this.userPermissions === 'none' && document.officeOnlineType){
        //   this.documentActions.doAction({ action: 'edit', file: document});
        // }else if(this.userPermissions !== 'none'){
          this.documentActions.doAction({ action: 'download', file: document});
        // }
        break;
      default:
        this.attachDocumentModal();
        break;
    }
  }

  upDocument(){
    let that: any = this.attachmentsTemplate;
    let addDocument:string = 'addNewDocumentsFromTasks';
    let listDocuments: any = [];
    if(this.isLanding && that.itemSelected.conceptObjectId && !that.itemSelected.taskId){
      addDocument = 'addNewDocumentsFromLanding';
    }else if((this.typeFrom === 'task') && !that.itemSelected.taskId && !that.itemSelected.conceptObjectId){
      addDocument = 'addNewDocumentsFromTasksNew';
    }else if(this.isLanding && that.itemSelected.conceptId && !that.itemSelected.taskId){
      addDocument = 'addNewDocumentsFromConceptsNew';
    }

    if(this.currentComponent === 'genericTask'){
      listDocuments = that.attachmentList;
    }else if(this.isLanding){
      listDocuments = that.attachmentList;
    }else{
      listDocuments = [...that.concept.documentation.documents, ...that.attachmentList];
    }
    let listStates:any = [];
    if(that.concept && that.concept.listStates){
      listStates = that.concept.listStates;
    }
    this.modalService.uploadDocuments(addDocument, [], listDocuments, that.itemSelected, listStates)
      .subscribe((result:any)=>{
        if(result.result === 'ok'){
          that.newDocuments = [...that.newDocuments, ...result.files];
          if(this.isLanding){
            if(addDocument === 'addNewDocumentsFromConceptsNew'){
              result.files.forEach((file:any) => {
                let modified = new Date();
                file.modified = modified.getTimezoneOffset() < 0? moment(modified.setMinutes(Math.abs(modified.getTimezoneOffset()) + modified.getMinutes())).toISOString() : moment(modified).toISOString()
                let newDocument = {
                  contentType: file.contentType,
                  fileSize: file.fileSize,
                  name: file.originalFileName,
                  extension: file.originalFileName.substr(file.originalFileName.lastIndexOf('.')+1, file.originalFileName.length),
                  modified: file.modified,
                  canBeDeleted: true,
                  documentObjectId: this.commonUtilsService.createId()
                }
                that.concept.documentation.documents.push(newDocument);
                that.concept.documentation.totalDocuments++;
                that.attachmentList.push(newDocument);
              });

              let documents:any = {
                type: 'addDocumentToNewConcept',
                list: that.newDocuments
              }
              this.launchAction.emit(documents);
            }else{
              that.attachmentList = [...that.attachmentList, ...result.files];
            }
          }else if(addDocument === 'addNewDocumentsFromTasksNew'){
            let newDocuments:any = cloneDeep(result.files);
            result.files.forEach((fileAdded:any) => {
              fileAdded.name = fileAdded.originalFileName;
              fileAdded.extension = fileAdded.name.substr(fileAdded.name.lastIndexOf('.')+1, fileAdded.name.length);
              fileAdded.canBeDeleted = true;
              fileAdded.documentObjectId = this.commonUtilsService.createId();
              let modified:any = new Date();
              fileAdded.modified = modified.getTimezoneOffset() < 0? moment(modified.setMinutes(Math.abs(modified.getTimezoneOffset()) + modified.getMinutes())).toISOString() : moment(modified).toISOString();
              if(that.concept){
                fileAdded.sourceName = that.itemSelected.title;
                fileAdded.source = 'Task';
              }
            })
            that.attachmentList = [...that.attachmentList, ...result.files];
            let documents:any = {
              type: 'addDocumentToTaskNew',
              list: newDocuments,
              listModified: result.files
            }
            this.launchAction.emit(documents);
          }else if(that.concept){
            result.files.forEach((file:any) => {
              file.sourceName = that.itemSelected.title;
              file.source = 'Task';
              that.attachmentList.push(file);
              that.concept.documentation.documents.push(file);
              that.concept.documentation.totalDocuments++;
            })
          }
          if(that.itemSelected && (that.itemSelected.taskId) && result.comments !== ''){
            let comment:any = {
              type: 'addCommentToTask',
              comments : result.comments
            }
            this.launchAction.emit(comment);
          }
          this.modalService.successModal({text: this.translate.instant('attachments.add-ok-documentation')});
        }
      })
  }

  deleteDocument(document:any){
    let that: any = this.attachmentsTemplate;
    this.modalService.infoModal({ text: this.translate.instant('documentation-list.question-delete-document') , typeButtons:'cancelRemove' })
      .subscribe((result:any)=>{
        if(result.result==='ok'){
          this.loader.openLoader('attachments-template-delete');
          if(that.itemSelected.conceptObjectId || that.itemSelected.taskId){
            this.deleteDocumentSelected(document);
          }else if(that.itemSelected.conceptId || document.canBeDeleted){
            this.deleteDocumentForList(document);
          }
        }else if(result.result==='cancelRemove'){

        }
      })
  }

  deleteDocumentForList(documentDeleted:any){
      let that: any = this.attachmentsTemplate;
      that.attachmentList = this.commonUtilsService.deleteElement(documentDeleted, that.attachmentList, 'documentObjectId');
      that.newDocuments = this.commonUtilsService.deleteElement(documentDeleted, that.newDocuments, 'documentObjectId');
      let type:string = 'deleteDocumentToConceptNew';
      if(this.typeFrom === 'task'){
          type = 'deleteDocumentToTaskNew';
      }else{
          this.commonUtilsService.deleteDocumentToField(documentDeleted, that.concept);
          if(that.concept.fieldsWidthDocuments && that.concept.fieldsWidthDocuments.length){
              this.deleteDocumentForFieldsWidthDocuments(documentDeleted);
          }
          if(that.concept && that.concept.documentation){
            this.deleteDocumentFromDocumentation(documentDeleted);
          }
      }
      let documents:any = {
          type: type,
          list: that.newDocuments,
          document: documentDeleted
      }
      this.launchAction.emit(documents);
  }

  deleteDocumentForFieldsWidthDocuments(documentDeleted:any){
    let that: any = this.attachmentsTemplate;
    for(let [index, container] of that.concept.fieldsWidthDocuments.entries()){
      for(let [indexJ, documentField] of container.documents.entries()){
        if(documentField.documentObjectId === documentDeleted.documentObjectId){
          that.concept.fieldsWidthDocuments[index].documents.splice(indexJ, 1);
        }
      }
    }

  }

  deleteDocumentFromDocumentation(documentDeleted:any){
    let that: any = this.attachmentsTemplate;
    for(let [index, document] of that.concept.documentation.documents.entries()){
        if(document.documentObjectId === documentDeleted.documentObjectId){
            that.concept.documentation.documents.splice(index, 1);
            break;
        }
    }
  }


  deleteDocumentSelected(document:any) {
    let that: any = this.attachmentsTemplate;
    let url:string = that.itemSelected?.taskId ? 'tasks/' + that.itemSelected.taskId : 'documentobjects';
    let id:any = that.itemSelected?.taskId ? document.documentObjectId + '/0' : document.documentObjectId;
    this.apiService.delete(url, id)
      .then((data:any)=>{
        that.attachmentList = this.commonUtilsService.deleteElement( document, that.attachmentList, 'documentObjectId');
       
        if(!that.itemSelected.taskId){
          this.commonUtilsService.deleteDocumentToField(document, that.concept);
        }
        this.loader.closeLoader(['attachments-template-delete']);
        let text: string = that.itemSelected?.taskId?this.translate.instant('attachments.delete-documentation-ok'):this.translate.instant('documentation-list.deleted-definited-ok');
        this.modalService.successModal({ text: text });
      }, (errorData:any)=>{
        this.loader.closeError();
        this.modalService.errorModal({ text: this.translate.instant('documentation-list.error-remove-document') });
      });
  }

  attachDocumentModal(){
    this.modalService.attachDocumentModal(this.attachmentsTemplate.itemSelected)
      .subscribe((result:any)=>{
        if(result.result ==='ok'){
          this.loader.openLoader('attachment-document');
          this.associatedDocuments(result);
        }
      })
  }

  associatedDocuments(result:any) {
    this.apiService.add('tasks/associatedocuments/' + this.attachmentsTemplate.itemSelected.taskId, result.documents)
      .then((data:any)=>{
        this.getAttachmentsDocument(true);
        if(this.attachmentsTemplate.itemSelected && this.attachmentsTemplate.itemSelected.taskId && result.comments !== ''){
          let comment:any = {
            type: 'addCommentToTask',
            comments : result.comments
          }
          this.launchAction.emit(comment);
        }
        this.loader.closeLoader(['attachment-document']);
      }, (errorData:any) => {
        this.loader.closeError();
        this.modalService.errorModal({ text: this.translate.instant('task-edit.add-documents-error') });
      });
  }

  createNewDocument(result:any) {
    let url: any = result.url;
    if (this.currentComponent === 'genericTask') {
      url = 'tasks/fromOfficeDocumentTemplate/' + this.attachmentsTemplate.itemSelected.taskId + '/' + result.formatId;
    }
    this.apiService.add(url, {name: result.name})
      .then((data:any) => {
        this.documentActions.doAction({ action: 'open', file: data });
        this.documentUploaded(data, result.comments);
      }, (errorData:any) => {
        this.loader.closeError();
        this.modalService.errorModal({ text: this.translate.instant('documentation-list.error-document') });
      });
  }

  documentUploaded(task:any, comments:any='') {
    this.attachmentsTemplate.attachmentList.push(task);
    this.broadcastService.broadcast('addNew', {});
    this.modalService.successModal({text: this.translate.instant('attachments.add-ok-documentation')});
    if(this.attachmentsTemplate.itemSelected && this.attachmentsTemplate.itemSelected.taskId && comments !== ''){
      let comment = {
        type: 'addCommentToTask',
        comments : comments
      }
      this.launchAction.emit(comment);
    }
    this.loader.closeLoader(['attachment-document']);
  }

  ngOnDestroy(){
    this.commonUtilsService.OnDestroy(this.subscribers);
  }
}
